const styles = {
  container: {
    pointerEvents: 'all',
    position: 'absolute',
    bottom: '60px',
    width: '300px',
    right: '10px',
  },
};

export default styles;
